import Sdk from "casdoor-js-sdk";
import { getCasdoorURL, getAppApiURL } from "../utils/serverUrl";

const baseSdkConfig = {
  serverUrl: getCasdoorURL(),
  clientId: process.env.REACT_APP_CLIENT_ID,
  organizationName: process.env.REACT_APP_ORGANIZATIONNAME,
  appName: process.env.REACT_APP_APPNAME,
  signinPath: "/api/signin",
};

const isPremises = () => process.env.REACT_APP_RUNNING_CONTEXT === "premises";
const isCloudLocal = () => process.env.REACT_APP_IS_CLOUD_LOCAL === "true";

export async function createCasdoorSdkWithRedirect() {
  let finalPath;

  if (isPremises() || isCloudLocal()) {
    finalPath = `${getAppApiURL()}/callback`;
  } else {
    try {
      const res = await fetch(`${getAppApiURL()}/unauth/serverConfig`);
      const data = await res.json();
      finalPath = `${data.serverUrl}/callback`;
    } catch {
      let redirectPath = getAppApiURL();
      redirectPath = redirectPath.replace(/^(https?:\/\/)?login\./, '$1');
      finalPath = `${redirectPath}/callback`;
    }
  }

  return new Sdk({
    ...baseSdkConfig,
    redirectPath: finalPath,
  });
}
